import c from "../../../utils/constants";

class ProfilesFilterController {
  constructor($scope, FilterService, EventsService) {
    "ngInject"

    this.filterService = FilterService;
    this.eventsService = EventsService;

    $scope.$watch("vm.filterOptions", this.onFilterChagne.bind(this), true)
  }

  $onInit() {
    this.setFilterOptions();

    this.eventsService.listen(c.events.GLOBAL_FILTER_APPLIED, (e, globalFilter) => {
      console.log("Global filter applied::", globalFilter);

      this.setFilterOptions(globalFilter.type);
    })
  }

  setFilterOptions(activeGlobalFilter) {
    this.filterOptions = this.filterService.getProfilesFilterOptions(activeGlobalFilter);
    return this.filterOptions;
  }

  onFilterChagne(newval, oldval) {
    // Apply filters only if filter options are changed
    let isFilterOptionsChanged = false;

    for(let i=0; i < newval.length; i++) {
      if(newval[i].isActive != oldval[i].isActive) {
        isFilterOptionsChanged = true;
        break;
      }

      if(newval[i].filterItemSelected != oldval[i].filterItemSelected) {
        isFilterOptionsChanged = true;
        break;
      }

      if(newval[i].value != oldval[i].value) {
        isFilterOptionsChanged = true;
        break;
      }
    }

    if(!isFilterOptionsChanged) return;

    this.filterService.generateFilterExpression(this.filterOptions);
    this.applyFilters();
  }

}

export default ProfilesFilterController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/profiles-filter/profiles-filter.controller.js
 **/